import type { BaseOptionType } from 'antd/es/select';

const CUSTOM_DEADLINE_ITEM_INDEX = 0;
const BEFORE_RECORD_DEADLINE_ITEM_INDEX = 6;
const AFTER_RECORD_DEADLINE_ITEM_INDEX = 7;

const DEADLINES_LIST: BaseOptionType[] = [
  {
    value: 1,
    label: 'В момент события',
  },
  {
    value: 2,
    label: 'Конец дня',
  },
  {
    value: 3,
    label: 'Через день',
  },
  {
    value: 4,
    label: 'Через 3 дня',
  },
  {
    value: 5,
    label: 'Через неделю',
  },
  {
    value: CUSTOM_DEADLINE_ITEM_INDEX,
    label: 'Задать свой срок',
  },
];
export const EXTRA_DEADLINES_LIST = [
  {
    value: BEFORE_RECORD_DEADLINE_ITEM_INDEX,
    label: 'До наступления записи',
  },
  {
    value: AFTER_RECORD_DEADLINE_ITEM_INDEX,
    label: 'После наступления записи',
  },
];

export const botDetailsOptions = {
  DEADLINES_LIST,
  CUSTOM_DEADLINE_ITEM_INDEX,
  BEFORE_RECORD_DEADLINE_ITEM_INDEX,
  AFTER_RECORD_DEADLINE_ITEM_INDEX,
};
